import {FAQ} from './FAQ';
import {SignIn} from './SignIn';
import {SignUp} from './SignUp';
import {Profile} from './Profile';
import {CardMenu} from './CardMenu';
import {Payments} from './Payments';
import {Onboarding} from './Onboarding';
import {Statistics} from './Statistics';
import {OpenNewLoan} from './OpenNewLoan';
import {NewPassword} from './NewPassword';
import {CardDetails} from './CardDetails';
import {IBANPayment} from './IBANPayment';
import {OpenDeposit} from './OpenDeposit';
import {OpenNewCard} from './OpenNewCard';
import {InvoiceSent} from './InvoiceSent';
import {TopUpPayment} from './TopUpPayment';
import {FundTransfer} from './FundTransfer';
import {OpenMoneybox} from './OpenMoneybox';
import {ChangePINCode} from './ChangePINCode';
import {MobilePayment} from './MobilePayment';
import {CreateInvoice} from './CreateInvoice';
import {PaymentFailed} from './PaymentFailed';
import {PrivacyPolicy} from './PrivacyPolicy';
import {ForgotPassword} from './ForgotPassword';
import {PaymentSuccess} from './PaymentSuccess';
import {ConfirmationCode} from './ConfirmationCode';
import {EditPersonalInfo} from './EditPersonalInfo';
import {TransactionDetails} from './TransactionDetails';
import {SignUpAccountCreated} from './SignUpAccountCreated';
import {VerifyYourPhoneNumber} from './VerifyYourPhoneNumber';
import {ForgotPasswordSentEmail} from './ForgotPasswordSentEmail';
import {CreateTask} from './CreateTask';
import {EditTask} from './EditTask';
import {TaskDetails} from './TaskDetails';
import {CheckerTask} from './CheckerTask';
import {PreCheckReports} from './PreCheckReports';
import {PreCheckReportForm} from './PreCheckReportForm';
import {TaskSubmission} from './TaskSubmission';
import {TaskReview} from './TaskReview';
import {LeaveRequest} from './LeaveRequest';
import {LoanRequest} from './LoanRequest';
import {DocumentHistory} from './DocumentHistory';
import {CorrectionDetail} from './CorrectionDetail';
import {LoanDetail} from './LoanDetail';
// import {Schedule} from './Schedule';
import {LeaveDetails} from './LeaveDetails';
import {CreateActivity} from './CreateActivity';
import {Attendance} from './Attendance';
import {NotFound} from './NotFound';
import {Inbox} from './Inbox';
import {MarketingActivity} from './MarketingActivity';
import {CreateMarketingActivity} from './CreateMarketingActivity';
import {DetailMarketingActivity} from './DetailMarketingActivity';
import {EventActivity} from './EventActivity';
import {CreateEventActivity} from './CreateEventActivity';
import {DetailEventActivity} from './DetailEventActivity';
import {SurveyActivity} from './SurveyActivity';
import {CreateSurveyActivity} from './CreateSurveyActivity';
import {DetailSurveyActivity} from './DetailSurveyActivity';
import {Payslip} from './Payslip';
import {TenantSelect} from './TenantSelect';
import {ResetPassword} from './ResetPassword';
import {TravelExpenseForm} from './TravelExpenseForm';
import {TravelExpenseDetail} from './TravelExpenseDetail';
import {TravelExpenseRecapForm} from './TravelExpenseRecapForm';
import {TimeSheetForm} from './TimeSheetForm';
import {ChatRoom} from './ChatRoom';
import {PublicSurvey} from './PublicSurvey';
import {CallScreen} from './CallScreen';

// Tabs
import {More} from './tabs/More';
import {Loans} from './tabs/Loans';
import {Task} from './tabs/Task';
import {Deposits} from './tabs/Deposits';
import {Dashboard} from './tabs/Dashboard';
import {Notification} from './tabs/Notification';
import {LeaveHistory} from './tabs/LeaveHistory';
import {PersonalData} from './tabs/PersonalData';
import {Activity} from './tabs/Activity';
import {Contacts} from './tabs/Contacts';

export const screens = {
  FAQ,
  More,
  Loans,
  Task,
  SignIn,
  SignUp,
  Profile,
  Payments,
  Deposits,
  CardMenu,
  Dashboard,
  Statistics,
  Onboarding,
  OpenDeposit,
  CardDetails,
  OpenNewLoan,
  OpenNewCard,
  IBANPayment,
  NewPassword,
  InvoiceSent,
  Notification,
  FundTransfer,
  TopUpPayment,
  OpenMoneybox,
  CreateInvoice,
  MobilePayment,
  ChangePINCode,
  PrivacyPolicy,
  PaymentFailed,
  PaymentSuccess,
  ForgotPassword,
  ConfirmationCode,
  EditPersonalInfo,
  TransactionDetails,
  SignUpAccountCreated,
  VerifyYourPhoneNumber,
  ForgotPasswordSentEmail,
  CreateTask,
  EditTask,
  TaskDetails,
  CheckerTask,
  PreCheckReports,
  PreCheckReportForm,
  TaskSubmission,
  TaskReview,
  LeaveRequest,
  LoanRequest,
  DocumentHistory,
  CorrectionDetail,
  LoanDetail,
  LeaveHistory,
  // Schedule,
  LeaveDetails,
  PersonalData,
  Activity,
  MarketingActivity,
  CreateMarketingActivity,
  DetailMarketingActivity,
  EventActivity,
  CreateEventActivity,
  DetailEventActivity,
  SurveyActivity,
  CreateSurveyActivity,
  DetailSurveyActivity,
  CreateActivity,
  Attendance,
  NotFound,
  Inbox,
  Payslip,
  TenantSelect,
  ResetPassword,
  TravelExpenseForm,
  TravelExpenseDetail,
  TravelExpenseRecapForm,
  TimeSheetForm,
  ChatRoom,
  PublicSurvey,
  CallScreen,
  Contacts,
};
